/**
 * AcceptInvitationRoute — router-level dispatcher for
 * `/accept-invitation`. The invitation email link is fixed at
 * `${FE_URL}/accept-invitation?token=…` (see
 * `apps/api/src/modules/identity/infrastructure/email/
 * smtp-email.renderer.ts`), so this is the single FE entry point.
 *
 * The dispatcher only reads the `?token` query param and hands it
 * down. Token validation, preview, and accept all live in
 * AcceptInvitationConsumePage so the consume page is testable in
 * isolation without a Router context.
 */

import * as React from 'react';
import { useSearchParams } from 'react-router-dom';
import { AcceptInvitationConsumePage } from './AcceptInvitationConsumePage.js';

export function AcceptInvitationRoute(): React.ReactElement {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') ?? '';
  return <AcceptInvitationConsumePage token={token} />;
}
